import styled from "styled-components";
import grain from "./../../assets/images/grain.svg";
import Lottie from "lottie-react";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-blend-mode: multiply;
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  &&::-webkit-scrollbar {
    display: none;
  }
`;

export const PlayGround = styled.div`
  height: 50%;
  aspect-ratio: (1 / 2);
  /* margin: 50px; */
  flex-direction: column;
  max-width: 380px;
  display: flex;
  flex: 1;
`;

export const MatchBoxStrip = styled.img`
  height: 20px;
  width: 100%;
  aspect-ratio: (1/2);
`;

export const CenterArea = styled.div`
  background-color: #463048;
  width: 380px;
  height: 656px;
  display: flex;
  color: #171312;
  background-image: url(${grain});
  background-blend-mode: multiply;
  background-size: cover;
  background-repeat: no-repeat;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow-y: scroll;
  &&::-webkit-scrollbar {
    display: none;
  }
`;

export const CenterAreaOne = styled.div`
  flex: 1;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin-top: 0px;
`;

export const Board = styled.button`
  width: 100px;
  height: 150px;
  align-items: center;
  display: flex;
  flex-direction: column;
  background: none;
  justify-content: flex-end;
  border: none;
  margin: 20px 4px;
  :active {
    transform: translateY(2px);
  }
`;

export const MatchBoxStripArea = styled.span`
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
`;

export const MatchBoxStripButton = styled.button`
  position: absolute;
  right: 0;
  height: 100%;
  background-color: transparent;
  background: none;
  border: none;
  top: 1.75px;
  cursor: pointer;
  width: 30px;
  height: 38px;
`;

export const Animation = styled.div`
  position: absolute;
  background-color: "red";
  right: -5px;
  bottom: 45px;
`;

export const LottieAnimation = styled(Lottie)`
  height: 100px;
  width: 100px;
  display: ${(props) => (props.info ? "none" : "")};
`;

export const ModalButton = styled.button`
  cursor: pointer;
  :active {
    transform: translateY(1px);
  }
  font-size: 14px;
`;
export const OuterDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  width: 380px;
  margin-top: 20px;
  margin-bottom: 10px;
  /* background-color:pink; */
`;

export const Button = styled.button`
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 30px;
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: pointer;
`;
export const ButtonImg = styled.img`
  width: 30px;
  height: 30px;
`;